import React, { useRef } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
  Desktop,
  Mobile,
  MobileAndTablet,
  DesktopAndTablet,
} from 'Responsive';
import LinkWithHashChange from 'LinkWithHashChange';
import useScrolledPast from 'hooks/useScrolledPast';

const TaxStickyBar = ({
  ctaLink,
  documentName,
  secondaryCtaDocName,
  secondaryCtaLink,
  taxYear: taxYearProp,
}) => {
  const navbarTriggerRef = useRef(null);
  const isStickyBarVisible = useScrolledPast(navbarTriggerRef);

  const navBarContainerStyle = {
    width: '100%',
    position: 'fixed',
    left: 0,
    top: 0,
    zIndex: 2,
  };

  const navBarStyle = {
    position: 'relative',
    zIndex: 10,
    paddingTop: 10,
    paddingBottom: 10,
  };

  const linkCommonProps = {
    isDynamic: true,
    spy: true,
    duration: 500,
  };


  if (!isStickyBarVisible) {
    navBarContainerStyle.display = 'none';
  }

  let desktopText = `Fill Out ${documentName} for ${taxYearProp}`;
  desktopText = secondaryCtaLink ? `Fill Out Form ${documentName}` : desktopText;
  const mobileText = secondaryCtaDocName ? `${documentName}` : `Fill Out ${documentName}`;
  const secondaryCtaDesktopText = `Fill Out Form ${secondaryCtaDocName}`;
  const secondaryCtaMobileText = `${secondaryCtaDocName}`;
  const mobileFaqText = secondaryCtaDocName ? 'FAQs' : 'Back to FAQs';
  const secondaryCtaClassNames = classNames(
    'btn',
    'btn-primary',
    'btn-lg',
    'head-term-state-dropdown-button',
    'with-padding',
    'with-nec-cta',
    'inline-nec-cta',
  );

  return (
    <React.Fragment>
      <div className="tax-lp-sticky-bar-container" style={navBarContainerStyle}>
        <div
          className="tax-lp-sticky-bar"
          style={navBarStyle}
        >
          <div className="formswift-logo" >
            <a href="/"><img alt="FormSwift" src="/images/logo-on-white.svg" /></a>
          </div>
          <div className="builder-button">
            {secondaryCtaLink &&
              <a
                className={secondaryCtaClassNames}
                href={secondaryCtaLink}
              >
                <DesktopAndTablet>
                  {secondaryCtaDesktopText}
                </DesktopAndTablet>
                <Mobile>
                  {secondaryCtaMobileText}
                </Mobile>
              </a>
            }
            <a
              href={ctaLink}
              className="btn btn-success btn-lg head-term-state-dropdown-button with-padding"
            >
              <DesktopAndTablet>
                {desktopText}
              </DesktopAndTablet>
              <Mobile>
                {mobileText}
              </Mobile>
            </a>
          </div>
          <div className="back-to-faq">
            <Desktop>
              <LinkWithHashChange
                smooth
                to="frequentlyAskedQuestionsDesktop"
                {...linkCommonProps}
              >
                Back to FAQs
              </LinkWithHashChange>
            </Desktop>
            <MobileAndTablet>
              <LinkWithHashChange
                smooth
                to="frequentlyAskedQuestionsMobile"
                {...linkCommonProps}
              >
                {mobileFaqText}
              </LinkWithHashChange>
            </MobileAndTablet>
          </div>
        </div>
      </div>
      <div ref={navbarTriggerRef} />
    </React.Fragment>
  );
};

TaxStickyBar.init = (id, props) => {
  ReactDOM.render(
    <TaxStickyBar {...props} />,
    document.getElementById(id),
  );
};

TaxStickyBar.defaultProps = {
  secondaryCtaDocName: '',
  secondaryCtaLink: '',
};

TaxStickyBar.propTypes = {
  ctaLink: PropTypes.string.isRequired,
  documentName: PropTypes.string.isRequired,
  secondaryCtaDocName: PropTypes.string,
  secondaryCtaLink: PropTypes.string,
  taxYear: PropTypes.string.isRequired,
};

export default TaxStickyBar;



// WEBPACK FOOTER //
// ./src-react/TaxStickyBar/index.jsx